import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { User } from '../models/user.model';

@Injectable()
export class AuthService {

  private user: User ;

  constructor(private userService: UserService) {

  }
  
  // Anmeldung -------------------------------------------------
  login(username: string, password: string): boolean {
    // Anmelden über Service ----------------------------
    //this.user = this.userService.login(username, password);
    this.userService.login(username, password)
      .subscribe(anmeldung => {
        this.user = anmeldung;
       });

    return false;
  }

 // Abmelden --------------------------------------------------
  logout(): any {
    this.userService.logout(this.user.Benutzer)
      .subscribe(abmeldung => {
        this.user = abmeldung;
       });
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('token');
    console.log("Token entfernt");

    this.user = null;
  }

// gibt die gesamten Userdaten zurück ------------------------
  getUser(): any {
    return this.user;
  }

// gibt den Benutzernamen zurück ------------------------
  getUserName(): string {
    return this.user.Benutzer;
  }

// gibt den ganzen Benutzernamen (Vorname + Nachname) zurück ------------------------
  getUserFullName(): string {
    return this.user.Vorname + " " + this.user.Nachname;
  }

// gibt das SessionToken zurück
  getToken(): any {
    return sessionStorage.getItem('token');
  }

// gibt einen boolean-Wert zurück, ob der Benutzer angemeldet ist oder nicht
  isLoggedIn(): boolean {
    return this.getToken() !== null;
  }
}

export const AUTH_PROVIDERS: Array<any> = [
  { provide: AuthService, useClass: AuthService }
];




// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/services/auth.service.ts